import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { installToughKeyWindowCallbacks } from './tough-key-window-bootstrap';

/** Do not overwrite test-secure-terminal-demo-parity.js host callbacks (loaded on delegation routes). */
const w = globalThis as {
  CefSharp?: unknown;
  __toughKeyDemoParityLoaded?: boolean;
  __toughKeyVanillaCallbacks?: boolean;
};
/** CefSharp hosts use tough-key-secure-terminal-demo-parity.js only — sync stubs break re-init popups. */
if (!w.__toughKeyDemoParityLoaded && !w.__toughKeyVanillaCallbacks) {
  if (!w.CefSharp) {
    installToughKeyWindowCallbacks();
  } else {
    console.warn(
      '[ToughKey] tough-key-secure-terminal-demo-parity.js missing — Connect uses bindToughKey; ' +
        'admin init uses toughkey-admin-init-shell.html. Rebuild www and Ctrl+F5 if in-SPA init is needed.'
    );
  }
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    const win = globalThis as { __toughKeyDemoParityLoaded?: boolean };
    if (win.__toughKeyDemoParityLoaded) {
      console.log('[ToughKey] Demo parity loaded — delegation uses test-secure-terminal-demo.html flow');
    }
  })
  .catch((err) => console.error(err));
